export const columnDescriptions = {
    codcli: "Código",
    cgccli: "CNPJ/CPF",
    tipcli: "Tipo fornecedor",
    nomcli: "Nome fornecedor",
    fancli: "Nome fantasia",
    insest: "Inscrição estadual",
    tipserv: "Tipo serviço",
    descserv: "Descrição serviço",
    cepcli: "CEP fornecedor",
    estcid: "Estado",
    baicli: "Bairro",
    endcli: "Endereço",
    codcid: "Cód. Cidade",
    nomcid: "Nome Cidade",
    endele: "E-mail pri.",
    endalt: "E-mail sec.",
    concli: "Contato",
    foncla: "Telefone pri.",
    fonclb: "Telefone sec.",
    celcli: "Celular",
    siteurlcli: "Website",
    redesoccli: "Redes sociais",
    cliafa: "Status Atividade", 
    cadinipfaprov: "Status Ava. Fiscal",
    datcadinipf: "Data Ava. Fiscal", 
    cadfinpfaprov: "Status Ava. Final",
    datcadfinpf: "Data Ava. Final", 
    priacpf: "Primeiro Acesso"
};